// extracted by mini-css-extract-plugin
module.exports = {"container":"ShopsLink_container__Rsgv5","text":"ShopsLink_text__MubDj","icon":"ShopsLink_icon__ceoTu"};